import { HUBSPOT_DEFINED, USER_DEFINED, INTEGRATOR_DEFINED } from './AssociationCategory';
import { HUBSPOT_DEFINED_TYPE, USER_DEFINED_TYPE, INTEGRATOR_DEFINED_TYPE } from './AssociationCategoryTypes';
export const categoryToType = {
  [HUBSPOT_DEFINED]: HUBSPOT_DEFINED_TYPE,
  [USER_DEFINED]: USER_DEFINED_TYPE,
  [INTEGRATOR_DEFINED]: INTEGRATOR_DEFINED_TYPE
};
export const typeToCategory = {
  [HUBSPOT_DEFINED_TYPE]: HUBSPOT_DEFINED,
  [USER_DEFINED_TYPE]: USER_DEFINED,
  [INTEGRATOR_DEFINED_TYPE]: INTEGRATOR_DEFINED
};
export const ASSOCIATION_DIRECTION = {
  STANDARD: 'STANDARD',
  INVERSE: 'INVERSE'
};
export const HIDDEN_REASON = {
  DEFAULT: 'DEFAULT',
  INTERNAL: 'INTERNAL',
  USER_CONFIGURED: 'USER_CONFIGURED'
};
export const getLabel = (assn, associationDirection) => {
  if (associationDirection === ASSOCIATION_DIRECTION.INVERSE) {
    return assn.inverseLabel;
  }
  return assn.label;
};
export const getInverseLabel = (assn, associationDirection) => {
  if (associationDirection === ASSOCIATION_DIRECTION.INVERSE) {
    return assn.label;
  }
  return assn.inverseLabel;
};
export const getId = (assn, associationDirection) => {
  if (associationDirection === ASSOCIATION_DIRECTION.INVERSE) {
    return assn.inverseId;
  }
  return assn.id;
};
export const getInverseId = (assn, associationDirection) => {
  if (associationDirection === ASSOCIATION_DIRECTION.INVERSE) {
    return assn.id;
  }
  return assn.inverseId;
};
export const shouldHideAssociation = association => {
  if (!association.get('hidden')) {
    return false;
  }
  const hiddenReason = association.get('hiddenReason');
  return hiddenReason === HIDDEN_REASON.USER_CONFIGURED || hiddenReason === HIDDEN_REASON.DEFAULT;
};